import {
  EventListPageType,
  type EventListPageTypeString,
} from '~/composables/types/strapiEventListPage'

export const TRANSACTIONAL_PAGE_SIMPLE_SHOWCASE_LIMIT = 3

/** Sales- and review-oriented ordering for transactional showcase picks */
export const TRANSACTIONAL_PAGE_SIMPLE_SHOWCASE_ORDER_BY =
  'trending_90_days,avg_review,has_events'

export interface TransactionalPageShowcaseSearchContext {
  pageType: EventListPageTypeString
  locationSlug: string | undefined
  categorySlug: string
  /** KFT tag slug (from Strapi `searchFilters.tags[].value`) */
  tagFilterSlug?: string
  publishedSearchToken: 'konfettiPublished:1'
}

export const buildTransactionalPageShowcaseSearchParts = (
  ctx: TransactionalPageShowcaseSearchContext
): string[] => {
  const parts = [ctx.publishedSearchToken]

  const useCity =
    ctx.locationSlug &&
    !ctx.locationSlug.includes('--') &&
    (ctx.pageType === EventListPageType.CITY ||
      ctx.pageType === EventListPageType.CITY_CATEGORY)

  if (useCity) {
    parts.push(`city:${ctx.locationSlug}`)
  }

  if (
    (ctx.pageType === EventListPageType.CATEGORY ||
      ctx.pageType === EventListPageType.CITY_CATEGORY) &&
    ctx.categorySlug
  ) {
    parts.push(`category:${ctx.categorySlug}`)
  }

  if (
    (ctx.pageType === EventListPageType.GENERAL ||
      ctx.pageType === EventListPageType.TEAMEVENT) &&
    ctx.tagFilterSlug
  ) {
    parts.push(`tag:${ctx.tagFilterSlug}`)
  }

  return parts
}
